import { normalizeExcelCell } from "./convert-cell-to-text-or-date"

export function checkForExcelErrors(sheet) {
    const invalidCells = []

    sheet.eachRow((row) => {
        row.eachCell((cell) => {
            const excelError = findExcelError(cell.value)
            if (excelError) {
                invalidCells.push({
                    cell: cell.address,
                    error: excelError,
                })
                return
            }

            const normalizedValue = normalizeExcelCell(cell)
            if (normalizedValue !== cell.value) {
                cell.value = normalizedValue
            }
        })
    })

    return {
        sheet,
        invalidCells,
    }
}

function findExcelError(value) {
    if (!value || typeof value !== "object") return null
    if (typeof value.error === "string") return value.error
    if ("result" in value) return findExcelError(value.result)
    return null
}
